"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PriceDetails = _interopRequireDefault(require("./PriceDetails"));

var _HotelInfo = _interopRequireDefault(require("./HotelInfo"));

var _ImageCarousel = _interopRequireDefault(require("@airasia/phoenix-components/components/ImageCarousel"));

var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));

var _HotelCard = require("./HotelCard.proptypes");

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Timer = _interopRequireDefault(require("@airasia/phoenix-components/components/Timer"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _constant = require("../Card/constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__Container",
  componentId: "sc-mub93g-0"
})(["", ";max-width:", ";box-shadow:0 1px 4px rgba(0,0,0,0.16);border-radius:4px;", " font-family:", ";cursor:pointer;", ";", ";"], function (_ref) {
  var isMobile = _ref.isMobile,
      isCarouselCard = _ref.isCarouselCard;
  return !isCarouselCard && (!isMobile ? 'min-height: 216px' : 'min-height: 320px');
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '100%' : '912px';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
}, function (_ref5) {
  var templateType = _ref5.templateType;
  return templateType === _constant.TEMPLATE_TYPE.HOTEL_CARD ? ' padding-left: 15px;' : '';
}, function (_ref6) {
  var isCarouselCard = _ref6.isCarouselCard;
  return isCarouselCard && 'height: 430px;';
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__Wrapper",
  componentId: "sc-mub93g-1"
})(["height:100%;display:flex;", ";", " ", " ", ";"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return !isMobile ? 'min-height: 216px' : 'min-height: 320px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref9) {
  var isMobile = _ref9.isMobile,
      highlight = _ref9.highlight,
      theme = _ref9.theme;
  return highlight && !isMobile ? "\n    border: 1px solid ".concat(theme.colors.secondary, ";\n    border-radius: 0 0 ").concat(theme.space.micro, " ").concat(theme.space.micro, ",\n    border-top: 0,\n    ") : "";
}, function (_ref10) {
  var isCarouselCard = _ref10.isCarouselCard;
  return isCarouselCard && 'justify-content: space-between';
});

var HighlightBar = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__HighlightBar",
  componentId: "sc-mub93g-2"
})(["width:100%;background:", ";border-radius:", ";display:block !important;box-sizing:border-box;padding:", ";min-height:40px;color:", ";font-size:", ";line-height:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.secondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.default;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.small;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.XLarge;
});

var CarouselWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__CarouselWrapper",
  componentId: "sc-mub93g-3"
})(["width:", ";", " ", ";"], function (_ref17) {
  var isMobile = _ref17.isMobile;
  return isMobile ? '100%' : '24%';
}, function (_ref18) {
  var isMobile = _ref18.isMobile;
  return isMobile && 'height: 150px;';
}, function (_ref19) {
  var isCarouselCard = _ref19.isCarouselCard;
  return isCarouselCard && 'height: 30%;';
});

var HotelDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__HotelDetailsWrapper",
  componentId: "sc-mub93g-4"
})(["width:", ";", ";", ";display:flex;flex-direction:column;justify-content:space-evenly;"], function (_ref20) {
  var isMobile = _ref20.isMobile;
  return isMobile ? '100%' : '60%';
}, function (_ref21) {
  var isCarouselCard = _ref21.isCarouselCard;
  return isCarouselCard && 'height: 30%;';
}, function (_ref22) {
  var isCarouselCard = _ref22.isCarouselCard;
  return !isCarouselCard && 'border-left: 1px solid #ededed;';
});

var TimerWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TimerWrapper",
  componentId: "sc-mub93g-5"
})(["background-color:", ";display:flex;justify-content:center;align-items:center;color:", ";min-height:42px;border-radius:", ";> *{font-size:", ";}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.primaryLight;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.primary;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.borderRadius.normal;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontSize.XSmall;
});

var TimerIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TimerIconWrapper",
  componentId: "sc-mub93g-6"
})(["margin-right:", ";"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.tiny;
});

var TextDashContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TextDashContainer",
  componentId: "sc-mub93g-7"
})(["margin-left:", ";margin-right:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.tiny;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.tiny;
});

var PriceDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__PriceDetailsWrapper",
  componentId: "sc-mub93g-8"
})(["width:", ";", ";", ";", ";"], function (_ref30) {
  var isMobile = _ref30.isMobile;
  return isMobile ? '100%' : '20%';
}, function (_ref31) {
  var isCarouselCard = _ref31.isCarouselCard;
  return !isCarouselCard && 'border-left: 1px solid #ededed;';
}, function (_ref32) {
  var isCarouselCard = _ref32.isCarouselCard;
  return isCarouselCard && 'padding-bottom: 10px;';
}, function (_ref33) {
  var isCarouselCard = _ref33.isCarouselCard,
      strikethroughPresent = _ref33.strikethroughPresent;
  return isCarouselCard && !strikethroughPresent && 'margin-top: 36px;';
});

var PLACEHOLDER_IMAGE = 'https://static.airasia.com/snap/images/hotel_image_holder.svg';

var BucketTitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__BucketTitleWrapper",
  componentId: "sc-mub93g-9"
})(["padding-top:8px;padding-bottom:12px;display:flex;align-items:center;justify-content:center;height:5%;"]);

var HotelCard = function HotelCard(_ref34) {
  var accessible = _ref34.accessible,
      salesTag = _ref34.salesTag,
      bigPointPromo = _ref34.bigPointPromo,
      images = _ref34.images,
      discountText = _ref34.discountText,
      strikeThrough = _ref34.strikeThrough,
      price = _ref34.price,
      totalPrice = _ref34.totalPrice,
      promoTag = _ref34.promoTag,
      amenities = _ref34.amenities,
      promoTitle = _ref34.promoTitle,
      promoDescription = _ref34.promoDescription,
      starRating = _ref34.starRating,
      hotelName = _ref34.hotelName,
      location = _ref34.location,
      distance = _ref34.distance,
      reviews = _ref34.reviews,
      tripAdvisorReviews = _ref34.tripAdvisorReviews,
      theme = _ref34.theme,
      translations = _ref34.translations,
      isMobile = _ref34.isMobile,
      facilities = _ref34.facilities,
      heroImage = _ref34.heroImage,
      onLoadImage = _ref34.onLoadImage,
      isImageCarouselEnabled = _ref34.isImageCarouselEnabled,
      onClick = _ref34.onClick,
      highlight = _ref34.highlight,
      locale = _ref34.locale,
      bucketTitle = _ref34.bucketTitle,
      templateType = _ref34.templateType,
      fomoLabel = _ref34.fomoLabel,
      isFomoTimerEnabled = _ref34.isFomoTimerEnabled,
      isCarouselCard = _ref34.isCarouselCard,
      expandCarouselArrowClickableArea = _ref34.expandCarouselArrowClickableArea,
      fomoTime = _ref34.fomoTime;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var amenityRowCount = Math.ceil(amenities.length / 4);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAmenityFocused = _useState2[0],
      setAmenityFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isPromoFocused = _useState4[0],
      setPromoFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      fomoEndTime = _useState6[0],
      setFomoEndTime = _useState6[1];

  var handleTimer = function handleTimer() {
    setFomoEndTime(null);
  };

  var formatStringDate = function formatStringDate(dateToFormat) {
    return "".concat((0, _format.default)(dateToFormat, 'yyyy-MM-dd'), "T").concat((0, _format.default)(dateToFormat, 'HH:mm:ss'));
  };

  (0, _react.useEffect)(function () {
    if (fomoTime) {
      try {
        var currentDateTime = new Date();
        var fomoTimeSplit = fomoTime.split(':');
        currentDateTime.setHours(currentDateTime.getHours() + Number(fomoTimeSplit[0]));
        currentDateTime.setMinutes(currentDateTime.getMinutes() + Number(fomoTimeSplit[1]));
        currentDateTime.setSeconds(currentDateTime.getSeconds() + Number(fomoTimeSplit[2]));
        setFomoEndTime(formatStringDate(currentDateTime));
      } catch (error) {
        setFomoEndTime(null);
      }
    }
  }, [fomoTime]);

  var onClickCalled = function onClickCalled(e) {
    e.preventDefault();
    onClick();
  };

  var getMain = function getMain(_ref35) {
    var imageList = _ref35.imageList;
    return /*#__PURE__*/_react.default.createElement(Container, {
      tabIndex: tabIndex,
      onClick: onClickCalled,
      isMobile: isMobile,
      templateType: templateType,
      isCarouselCard: isCarouselCard
    }, highlight && /*#__PURE__*/_react.default.createElement(HighlightBar, {
      className: "highlight-bar"
    }, promoTag), /*#__PURE__*/_react.default.createElement(Wrapper, {
      tabIndex: tabIndex,
      isMobile: isMobile,
      highlight: highlight,
      isCarouselCard: isCarouselCard
    }, bucketTitle && /*#__PURE__*/_react.default.createElement(BucketTitleWrapper, null, bucketTitle), /*#__PURE__*/_react.default.createElement(CarouselWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard
    }, !isImageCarouselEnabled ? /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage,
      width: "100%",
      height: "100%",
      onLoad: onLoadImage,
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: PLACEHOLDER_IMAGE
    }) : /*#__PURE__*/_react.default.createElement(_ImageCarousel.default, {
      responsive: [{
        breakPoint: 0,
        cardsToShow: 1
      }],
      infinite: true,
      expandCarouselArrowClickableArea: expandCarouselArrowClickableArea
    }, imageList.map(function (image) {
      return /*#__PURE__*/_react.default.createElement(_Image.default, {
        key: image,
        src: image,
        width: "100%",
        height: "100%",
        onLoad: onLoadImage,
        centerFocus: true,
        enableProgressiveImageLoading: true,
        lowResolutionImageUrl: PLACEHOLDER_IMAGE
      });
    }))), /*#__PURE__*/_react.default.createElement(HotelDetailsWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard
    }, /*#__PURE__*/_react.default.createElement(_HotelInfo.default, {
      promoTag: promoTag,
      promoTitle: promoTitle,
      freeCancellationText: translations === null || translations === void 0 ? void 0 : translations.freeCancellationText,
      payLaterText: translations === null || translations === void 0 ? void 0 : translations.payLaterText,
      payAtHotelText: translations === null || translations === void 0 ? void 0 : translations.payAtHotelText,
      lowInventoryAlert: translations === null || translations === void 0 ? void 0 : translations.lowInventoryAlert,
      amenities: amenities,
      starRating: starRating,
      hotelName: hotelName,
      location: location,
      distance: distance,
      reviews: reviews,
      tripAdvisorReviews: tripAdvisorReviews,
      setAmenityFocused: setAmenityFocused,
      title: translations === null || translations === void 0 ? void 0 : translations.amenityTitle,
      theme: theme,
      isMobile: isMobile,
      highlight: highlight,
      templateType: templateType,
      reviewTranslation: translations === null || translations === void 0 ? void 0 : translations.reviewTranslation
    })), /*#__PURE__*/_react.default.createElement(PriceDetailsWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard,
      strikethroughPresent: strikeThrough
    }, /*#__PURE__*/_react.default.createElement(_PriceDetails.default, {
      theme: theme,
      salesTag: salesTag,
      promoTag: promoTag,
      bigPointPromo: bigPointPromo,
      discountText: discountText,
      strikeThrough: strikeThrough,
      price: price,
      priceText: translations === null || translations === void 0 ? void 0 : translations.priceText,
      perGuestText: translations === null || translations === void 0 ? void 0 : translations.perGuestText,
      snapPriceText: translations === null || translations === void 0 ? void 0 : translations.snapPriceText,
      totalPrice: totalPrice,
      isAmenityFocused: isAmenityFocused,
      amenityRowCount: amenityRowCount,
      isMobile: isMobile,
      isPromoFocused: isPromoFocused,
      setPromoFocused: setPromoFocused,
      promoTitle: promoTitle,
      promoDescription: promoDescription,
      facilities: facilities,
      locale: locale,
      lowInventoryAlert: translations === null || translations === void 0 ? void 0 : translations.lowInventoryAlert,
      isCarouselCard: isCarouselCard
    }))), fomoEndTime && isFomoTimerEnabled && /*#__PURE__*/_react.default.createElement(TimerWrapper, null, /*#__PURE__*/_react.default.createElement(TimerIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "TimerIcon",
      fontsize: "normal",
      color: "primary"
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "primary",
      accessible: accessible,
      theme: theme
    }, fomoLabel), /*#__PURE__*/_react.default.createElement(TextDashContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "primary",
      accessible: accessible,
      theme: theme
    }, "-")), /*#__PURE__*/_react.default.createElement(_Timer.default, {
      accessible: true,
      allowLocaleFormat: false,
      color: "primary",
      dayLabel: "days",
      endDate: fomoEndTime,
      localeConfig: {
        hour: 'numeric',
        hour12: false,
        minute: 'numeric',
        second: 'numeric'
      },
      size: "XSmall",
      theme: "AIRASIA_CLASSIC",
      timeEndCallback: handleTimer
    })));
  };

  getMain.propTypes = _HotelCard.getMainPropType;
  return themeContext ? getMain({
    imageList: images
  }) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain({
    imageList: images
  }));
};

HotelCard.propTypes = _HotelCard.HotelCardPropTypes;
HotelCard.defaultProps = _HotelCard.HotelCardDefaultProps;
var _default = HotelCard;
exports.default = _default;